'use strict'

module.exports = class SponsoredDealsWidgetModel extends Backbone.Model
  url: '/partial/homepage/sponsored-deals-widget'